import { Controller } from "@hotwired/stimulus"

// Show or hide the per-ingredient figures on a recipe.
//
// Everything it reveals is already on the page — the show page is static, so
// the macros are known at render time and there is nothing to fetch. The
// switch flips one class and CSS does the rest.
//
// Separate from live-nutrition, which does the same job on the FORM but has
// to ask the server after every edit. Same appearance, different problem.
export default class extends Controller {
  toggle(event) {
    this.element.classList.toggle("shows-ingredient-macros", event.target.checked)
  }
}
